import React from 'react';
import clsx from 'clsx';

interface StatCardProps {
    isDark: boolean;
    icon: React.ElementType;
    value: string | number;
    label: string;
    subLabel?: React.ReactNode;
    colorClass?: string;
}

const StatCard: React.FC<StatCardProps> = ({ isDark, icon: Icon, value, label, subLabel, colorClass }) => (
    <div className={clsx('p-4 rounded-xl border', colorClass || (isDark ? 'bg-slate-800 border-slate-700' : 'bg-white border-slate-200'))}>
        <div className="flex items-center gap-3">
            <div className="p-2 rounded-lg bg-slate-100 dark:bg-slate-700">
                <Icon size={20} className="text-slate-500" />
            </div>
            <div>
                <p className="text-2xl font-bold text-slate-800 dark:text-white">{value}</p>
                <p className="text-sm text-slate-500">{label}</p>
            </div>
        </div>
        {subLabel && <div className="mt-2 text-xs">{subLabel}</div>}
    </div>
);

export default StatCard;
